import FeaturePermission from "./FeaturePermission";

export default FeaturePermission;
